module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/custom.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Blood Before Dawn")]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('p', {
    staticClass: "toc-ttl"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_vm._v("TABLE OF CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#c1",
      "id": "t1"
    }
  }, [_vm._v("Chapter 1 April 1979")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#c2",
      "id": "t2"
    }
  }, [_vm._v("Chapter 2 Winston")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c3",
      "id": "t3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 BAO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c4",
      "id": "t4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 “Mining Engineers”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c5",
      "id": "t5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 The Clandestine Service")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#c6",
      "id": "t6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 Wiesua")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#c7",
      "id": "t7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 The Meeting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#c8",
      "id": "t8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 Honorable Williams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#c9",
      "id": "t9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 The Opposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#c10",
      "id": "t10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 West African Air Services")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#c11",
      "id": "t11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 The Armed Forces of Liberia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#c12",
      "id": "t12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 The Big Meeting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#c13",
      "id": "t13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 Military Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#c14",
      "id": "t14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14 All The Proof You Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#c15",
      "id": "t15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15 In Too Deep")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#c16",
      "id": "t16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16 “One Picture is Worth a Thousand Words”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#c17",
      "id": "t17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17 Guns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#c18",
      "id": "t18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18 Stephens & Coe & Co.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#c19",
      "id": "t19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19 Trevor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#c20",
      "id": "t20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20 ARS-57")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#c21",
      "id": "t21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21 Precautions Taken")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#c22",
      "id": "t22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22 The Fishing Trip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#c23",
      "id": "t23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23 Skru Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#c24",
      "id": "t24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24 Voinjama")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#c25",
      "id": "t25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25 Binji")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#c26",
      "id": "t26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26 Mr. Chao")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#c27",
      "id": "t27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27 Adoption or Bondage?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#c28",
      "id": "t28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28 A Sense of Honor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#c29",
      "id": "t29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29 We Must Move On to Our Destiny")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#c30",
      "id": "t30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30 Tolbert and PAL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#c31",
      "id": "t31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31 Piers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#c32",
      "id": "t32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32 The Debriefing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33#c33",
      "id": "t33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33 PAL Demonstration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34#c34",
      "id": "t34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34 Repercussions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35#c35",
      "id": "t35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35 Two Days Before April 12, 1980")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36#c36",
      "id": "t36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36 April 12, 1980")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37#c37",
      "id": "t37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37 Betrayal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38#c38",
      "id": "t38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38 Monrovia Burning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39#c39",
      "id": "t39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39 The Other Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40#c40",
      "id": "t40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40 Mission Accomplished")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41#c41",
      "id": "t41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41 Kangaroo Court")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42#c42",
      "id": "t42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42 Escape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43#c43",
      "id": "t43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 43 Freetown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter44#c44",
      "id": "t44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 44 Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter01#c45",
      "id": "t45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter02#c46",
      "id": "t46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Books by Daniel V. Meier, Jr.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f6ec521","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contenttoc.vue
// module id = 66
// module chunks = 0